//Reset data
export const RESET = "USER_DEL_RESET"



//Loading
export const SET_TOGGLE_LOADING = "USER_DEL_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "USER_DEL_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "USER_DEL_SET_HIDE_LOADING"

//User
export const SET_USER = "USER_DEL_SET_USER"
export const SET_IS_SUCCESS = "USER_DEL_SET_IS_SUCCESS"
export const SET_IS_ERROR = "USER_DEL_SET_IS_ERROR"

export const SET_TOGGLE_USER = "USER_DEL_SET_TOGGLE_USER"
export const SET_SHOW_USER = "USER_DEL_SET_SHOW_USER"
export const SET_HIDE_USER = "USER_DEL_SET_HIDE_USER"

//Data
export const SET_ITEMS = "USER_DEL_SET_ITEMS"
export const SET_CURRENT_ITEM = "USER_DEL_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "USER_DEL_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "USER_DEL_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "USER_DEL_SET_HIDE_MODAL"


export const SET_MODAL = "USER_DEL_SET_MODAL"
export const SET_MODAL_CONTENT = "USER_DEL_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "USER_DEL_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "USER_DEL_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "USER_DEL_SET_MODAL_TYPE"
export const SET_MODAL_IS_UPDATE = "USER_DEL_SET_IS_UPDATE"